import React from 'react';

import { cx } from '@travel/utils';

import styles from './iconTextButton.module.scss';

type Props = {
  className?: string;
  textClassName?: string;
  contentContainerClassName?: string;
  /** Icon node to be displayed on left side */
  icon?: React.ReactNode;
  /**  Node of title of the text to be displayed above the text */
  title?: React.ReactNode;
  /** Node of text value to be displayed under the title if title does exist */
  text?: React.ReactNode;
  /** Flag to define whether the button style should be disabled or not */
  isDisabled?: boolean;
  /** Position of icon in relation to text, either to left or right */
  iconPosition?: 'left' | 'right';
} & Omit<React.HTMLAttributes<HTMLButtonElement>, 'icon' | 'title' | 'text'>;

function IconTextButton(props: Props) {
  const {
    className,
    textClassName,
    contentContainerClassName,
    icon,
    title,
    text,
    isDisabled,
    iconPosition = 'left',
    ...rest
  } = props;

  const isLeftPosition = iconPosition === 'left';

  return (
    <button
      className={cx(className, styles.wrapper, isDisabled && styles.disabled)}
      type="button"
      {...rest}
    >
      {isLeftPosition && icon && <div className={styles.noShrink}>{icon}</div>}
      <div className={cx(styles.content, contentContainerClassName)}>
        {title && <p className={styles.title}>{title}</p>}
        <p className={cx(styles.text, textClassName)}>{text}</p>
      </div>
      {!isLeftPosition && icon && <div className={styles.noShrink}>{icon}</div>}
    </button>
  );
}

export default IconTextButton;
